console.log('CUSTOM JS GELADEN');

document.addEventListener('DOMContentLoaded', () => {
  const APO_COLOR_SELECT = 'select.mw-option__control--type-select';
  let lastSelectedColor = '';
  let updateTimer = null;

  function norm(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/rosé/g, 'rose');
  }

  function isRealColor(value) {
    const v = norm(value);
    return !!v &&
      v !== '-- selecteer--' &&
      v !== 'selecteer' &&
      v !== 'selected transparent' &&
      v !== 'sealected transparent' &&
      v !== 'transparant' &&
      v !== '-';
  }

  function hideGallery() {
    document.body.classList.add('product-media-switching');
  }

  function showGallery() {
    document.body.classList.remove('product-media-switching');
  }

  function getSelectedApoColor() {
    const select = document.querySelector(APO_COLOR_SELECT);
    if (!select) return '';

    const selectedOption = select.options[select.selectedIndex];
    return norm(selectedOption?.textContent || selectedOption?.value);
  }

  function getEffectiveColor() {
    const currentColor = getSelectedApoColor();

    if (isRealColor(currentColor)) {
      lastSelectedColor = currentColor;
      return currentColor;
    }

    if (isRealColor(lastSelectedColor)) {
      return lastSelectedColor;
    }

    return '';
  }

  function getSelectedMaterial() {
    const checkedInput = document.querySelector('input[name^="Materiaal"]:checked');
    if (checkedInput) return norm(checkedInput.value);

    const fallbackChecked = document.querySelector('.product-form__input input[type="radio"]:checked');
    if (fallbackChecked) return norm(fallbackChecked.value);

    const select = document.querySelector('variant-selects select');
    if (select) {
      const option = select.options[select.selectedIndex];
      return norm(option?.textContent || select.value);
    }

    return '';
  }

  function getMaterialCode(material) {
    const m = norm(material);

    if (m.includes('zilver 925')) return 's';

    if (m.includes('9 kt geel') || m.includes('9kt geel')) return 'y';
    if (m.includes('14 kt geel') || m.includes('14kt geel') || m.includes('14 kt geelgoud') || m.includes('14kt geelgoud')) return 'y';

    if (m.includes('9 kt wit') || m.includes('9kt wit')) return 's';
    if (m.includes('14 kt wit') || m.includes('14kt wit') || m.includes('14 kt witgoud') || m.includes('14kt witgoud')) return 's';

    if (m.includes('9 kt rose') || m.includes('9kt rose')) return 'r';
    if (m.includes('14 kt rose') || m.includes('14kt rose') || m.includes('14 kt rosegoud') || m.includes('14kt rosegoud')) return 'r';

    return '';
  }

  function getMediaItems() {
    return Array.from(document.querySelectorAll('.product__media-item'));
  }

  function findMatchingMediaItem(color, material) {
    const items = getMediaItems();
    const materialCode = getMaterialCode(material);
    const colorKey = norm(color);

    if (!materialCode || !colorKey) return null;

    return items.find((el) => {
      const img = el.querySelector('img');
      const alt = norm(img?.getAttribute('alt'));
      const title = norm(img?.getAttribute('title'));
      const src = norm(img?.getAttribute('src'));

      const materialMatch =
        title.includes(`_${materialCode}_`) ||
        src.includes(`_${materialCode}_`);

      const colorMatch =
        alt.includes(colorKey) ||
        title.includes(colorKey) ||
        src.includes(`_${colorKey}`);

      return materialMatch && colorMatch;
    }) || null;
  }

  function activateMatchedMedia(mediaItem) {
    if (!mediaItem) return false;

    const mediaId = mediaItem.getAttribute('data-media-id');
    if (!mediaId) return false;

    const thumbButton =
      document.querySelector(`button[data-target="${mediaId}"]`) ||
      document.querySelector(`button[aria-controls="${mediaId}"]`) ||
      document.querySelector(`[data-thumbnail-id="${mediaId}"] button`) ||
      document.querySelector(`.thumbnail-list button[data-media-id="${mediaId}"]`) ||
      document.querySelector(`.slider-button[data-target="${mediaId}"]`);

    if (thumbButton) {
      thumbButton.click();
      return true;
    }

    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(`${mediaId}`, true);
      return true;
    }

    return false;
  }

  function updateImageFromState() {
    const color = getEffectiveColor();
    const material = getSelectedMaterial();

    if (!isRealColor(color)) {
      showGallery();
      return false;
    }

    const foundMedia = findMatchingMediaItem(color, material);
    if (!foundMedia) {
      showGallery();
      return false;
    }

    const applied = activateMatchedMedia(foundMedia);
    showGallery();
    return applied;
  }

  function scheduleUpdate(delay = 260) {
    if (updateTimer) {
      clearTimeout(updateTimer);
    }

    hideGallery();

    updateTimer = setTimeout(() => {
      updateImageFromState();
    }, delay);
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches(APO_COLOR_SELECT)) {
      const color = getSelectedApoColor();
      if (isRealColor(color)) {
        lastSelectedColor = color;
      }
      scheduleUpdate(180);
    }

    if (
      event.target.matches('input[name^="Materiaal"]') ||
      event.target.matches('.product-form__input input[type="radio"]') ||
      event.target.matches('variant-selects select')
    ) {
      scheduleUpdate(320);
    }
  });

  const apoContainer = document.querySelector('.mw-apo-container');
  if (apoContainer) {
    const observer = new MutationObserver(() => {
      const color = getSelectedApoColor();
      if (isRealColor(color)) {
        lastSelectedColor = color;
      }
      scheduleUpdate(180);
    });

    observer.observe(apoContainer, {
      childList: true,
      subtree: true
    });
  }

  setTimeout(() => {
    const color = getSelectedApoColor();
    if (isRealColor(color)) {
      lastSelectedColor = color;
    }
    updateImageFromState();
  }, 700);
});